import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import DepositModal from "./DepositModal";
import WithdrawModal from "./WithdrawModal";
import { Plus, ArrowDownToLine, Wallet, Banknote, Receipt } from "lucide-react";

export default function WalletBar() {
  const navigate = useNavigate();
  const [wallet, setWallet] = useState(null);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/wallet"); setWallet(data); } catch {}
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <>
      <div className="px-3 pt-2.5 pb-1 shrink-0" data-testid="wallet-bar">
        <div className="flex gap-2">
          <button data-testid="wallet-deposit-pill" onClick={() => setShowDeposit(true)}
            className="flex-1 flex items-center gap-2 px-3 py-2 rounded-2xl bg-gradient-to-br from-rose-500/15 to-rose-600/10 border border-rose-400/25 active:scale-[0.98] transition-transform">
            <div className="w-8 h-8 rounded-xl bg-rose-500/20 grid place-items-center shrink-0"><Wallet className="w-4 h-4 text-rose-300" /></div>
            <div className="min-w-0 text-left">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-rose-300/80 leading-none">Deposit</p>
              <p data-testid="wallet-deposit-balance" className="text-base font-black text-white leading-tight">₹{wallet?.deposit_balance ?? "—"}</p>
            </div>
            <span className="ml-auto w-6 h-6 rounded-full bg-rose-500 grid place-items-center shrink-0"><Plus className="w-4 h-4 text-white" strokeWidth={3} /></span>
          </button>

          <button data-testid="wallet-withdraw-pill" onClick={() => setShowWithdraw(true)}
            className="flex-1 flex items-center gap-2 px-3 py-2 rounded-2xl bg-gradient-to-br from-emerald-500/15 to-emerald-600/10 border border-emerald-400/25 active:scale-[0.98] transition-transform">
            <div className="w-8 h-8 rounded-xl bg-emerald-500/20 grid place-items-center shrink-0"><Banknote className="w-4 h-4 text-emerald-300" /></div>
            <div className="min-w-0 text-left">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-emerald-300/80 leading-none">Withdraw</p>
              <p data-testid="wallet-withdraw-balance" className="text-base font-black text-white leading-tight">₹{wallet?.withdrawal_balance ?? "—"}</p>
            </div>
            <span className="ml-auto w-6 h-6 rounded-full bg-emerald-500 grid place-items-center shrink-0"><ArrowDownToLine className="w-3.5 h-3.5 text-white" strokeWidth={3} /></span>
          </button>
        </div>
        <button data-testid="wallet-history-link" onClick={() => navigate("/earnings")}
          className="w-full mt-1.5 flex items-center justify-center gap-1.5 text-[11px] font-semibold text-slate-400 py-1 active:text-slate-200">
          <Receipt className="w-3.5 h-3.5" /> Earnings & transaction history
        </button>
      </div>

      {showDeposit && <DepositModal onClose={() => setShowDeposit(false)} onSuccess={load} />}
      {showWithdraw && <WithdrawModal onClose={() => setShowWithdraw(false)} onSuccess={load} />}
    </>
  );
}
